/*
Handles layout on the Meteor menu
*/
function applyMeteorLayout() {
  const menuIcon = document.querySelector('.icon-hamburger');

  if (menuIcon) {
    menuIcon.addEventListener('click', function () {
      const navElement = document.querySelector('.menu-drawer__navigation');

      if (navElement) {
        const anchorTags = navElement.querySelectorAll("a[href^='https://']");

        if (anchorTags?.length) {
          const paddingTopValue = '40px';
          anchorTags[0].style.setProperty('padding-top', paddingTopValue, 'important');

          anchorTags.forEach(function (anchor) {
            anchor.style.setProperty('font-weight', 'normal', 'important');
            anchor.style.setProperty('font-size', 'var(--p-regular-size)', 'important');
          });
        }
      }
    });
  }

  // Fix to open the Trade In nav link
  const navMenu = document.querySelector('.Meteor-DesktopNavigation');
  const lastNavItem = navMenu?.querySelector('li:last-child a');

  const lastLiItem = lastNavItem?.parentElement;
  if (lastLiItem) {
    lastLiItem.style.display = 'none';
  }

  // Add the lastNavItem before the closing nav tag
  const navElement = document.querySelector('.header__inline-menu');
  if (navElement && lastNavItem) {
    lastNavItem?.classList.add('lastNavItem');
    navElement?.appendChild(lastNavItem);
  }
}

if (window.addEventListener) {
  window.addEventListener('load', applyMeteorLayout);
}
